"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Svg(_ref) {
  var styles = _ref.styles;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "62",
    height: "62",
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: styles
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "62",
    height: "62"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "31",
    cy: "31",
    r: "31",
    fill: "#2F61E0"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "31",
    cy: "31",
    r: "31",
    fill: "#A6D4FF"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31 31C31 29.8954 30.1046 29 29 29H16C14.8954 29 14 29.8954 14 31V71L31 79V31Z",
    fill: "#2F61E0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33 31C33 29.8954 33.8954 29 35 29H51C52.1046 29 53 29.8954 53 31V45C53 46.1046 52.1046 47 51 47H35C33.8954 47 33 46.1046 33 45V38.5V31Z",
    fill: "#2F61E0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33 51C33 49.8954 33.8954 49 35 49H64C65.1046 49 66 49.8954 66 51V65C66 66.1046 65.1046 67 64 67H35C33.8954 67 33 66.1046 33 65V58.5V51Z",
    fill: "#2F61E0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M50 31C50 29.8954 50.8954 29 52 29H63C64.1046 29 65 29.8954 65 31V45C65 46.1046 64.1046 47 63 47H52C50.8954 47 50 46.1046 50 45V38.5V31Z",
    fill: "#2F61E0"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "33",
    cy: "47",
    r: "8",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "32",
    y: "43",
    width: "2",
    height: "8",
    rx: "1",
    fill: "#091E42"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "29",
    y: "48",
    width: "2",
    height: "8",
    rx: "1",
    transform: "rotate(-90 29 48)",
    fill: "#091E42"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 16.5C24 12 27 9 31.5 9C36 9 39 12.75 39 16.5C39 18.8326 36.8237 22.0357 32.471 26.1093C31.9154 26.6293 31.0585 26.6508 30.4775 26.1595C26.1592 22.5078 24 19.288 24 16.5ZM31.5 18C32.8807 18 34 16.8807 34 15.5C34 14.1193 32.8807 13 31.5 13C30.1193 13 29 14.1193 29 15.5C29 16.8807 30.1193 18 31.5 18Z",
    fill: "#091E42"
  }));
}

var _default = Svg;
exports.default = _default;